import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTower: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="tower, terminal"><path d="M9 2.75L15 2.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 2V5" stroke="currentColor" strokeWidth="1.5"/><path d="M17.5 9.75L19 5.75H5L6.5 9.75" stroke="currentColor" strokeWidth="1.5"/><path d="M21 9.75H3L5 14.25H19L21 9.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M9.75 14.25V21.25H14.25V14.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconTower;
